import { render } from "./Industries.vue?vue&type=template&id=39514f9a&scoped=true&ts=true"
import script from "./Industries.vue?vue&type=script&lang=ts"
export * from "./Industries.vue?vue&type=script&lang=ts"

import "./Industries.vue?vue&type=style&index=0&id=39514f9a&lang=scss&scoped=true"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39514f9a"]])

export default __exports__